import type { AxiosResponse } from "axios";

import { features } from "cortex/ui/src/ui/features";

import type { CancelableAxiosPromise, S3PutSuccess } from "./base";
import { baseService } from "./base";

type VistarNetwork = {
  id: number;
  api_key: string;
};

export const networkService = {
  load(): CancelableAxiosPromise {
    return baseService.get("/api/networks");
  },

  loadAll(): CancelableAxiosPromise {
    return baseService.get("/api/networks/all");
  },

  new(name: string, vistarNetwork?: VistarNetwork): CancelableAxiosPromise {
    const data: Record<string, unknown> = { name };
    if (vistarNetwork) {
      data.vistar_api_key = vistarNetwork.api_key;
      data.vistar_network_id = vistarNetwork.id;
    }

    return baseService.post("/api/network", data);
  },

  delete(networkId: number): CancelableAxiosPromise {
    return baseService.delete(`/api/network/${networkId}`);
  },

  get(networkId: number): CancelableAxiosPromise {
    return baseService.get(`/api/network/${networkId}`);
  },

  updateParams(
    networkId: number,
    params: Record<string, string | number | boolean>,
  ): Promise<AxiosResponse | S3PutSuccess> {
    const url = features.APP_PARAMETERS_V3
      ? `/api/network/v2/${networkId}/params`
      : `/api/network/${networkId}`;

    return baseService.put(url, { params: params });
  },

  updateFlags(
    networkId: number,
    flags: Record<string, string | number | boolean>,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/network/${networkId}/flags`, { flags: flags });
  },

  updateDetails(
    networkId: number,
    details: Record<string, unknown>,
  ): Promise<AxiosResponse | S3PutSuccess> {
    return baseService.put(`/api/network/${networkId}/details`, {
      agentVersion: details.agentVersion,
      disableRemoteUpdates: details.disableRemoteUpdates,
      day: details.day,
      hour: details.hour,
      playerVersion: details.playerVersion,
      sandboxStatus: details.sandboxStatus,
      networkName: details.networkName,
      operateParams: details.operateParams,
      fallbackContents: details.fallbackContents,
      mainApp: details.mainApp,
    });
  },
};

export default networkService;
